import * as React from "react";
import { OAuthProviderButtons, DEFAULT_OAUTH_PROVIDERS } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

// Google / Microsoft / GitHub (no Discord) — the subset unified's AuthScreen shows.
const THREE = DEFAULT_OAUTH_PROVIDERS.filter((p) =>
  ["google", "microsoft", "github"].includes(p.id),
);

export function OAuthProviderButtonsDemo() {
  // Drive `loadingProviderId` from a real click so the per-tile icon -> Spinner
  // morph is visible. We clear it after a tick to mimic an OAuth redirect that
  // never actually leaves the page in the showcase.
  const [loadingId, setLoadingId] = React.useState<string | undefined>(undefined);

  const onSelect = (id: string) => {
    setLoadingId(id);
    window.setTimeout(() => setLoadingId(undefined), 1600);
  };

  return (
    <Section
      id="oauth-provider-buttons"
      title="OAuthProviderButtons"
      description="One branded social sign-in row. Maps over the canonical OAuthProviderConfig[] and renders one tile per provider, composing the IconButton primitive (icon tiles) or the outline Button (labeled). Each tile is now an Onyx offset key — the nx-m notch + a subtle nx-rim keyline — and presses 2px diagonally onto a travel block. Logic stays with the consumer via onSelect(id); the row only renders, staggers in, and can morph one tile to a Spinner."
    >
      <VariantBlock label="Default" caption="icon tiles, 4-column grid (the AuthModal shape) — press a tile to feel the offset key">
        <div className="w-[360px]">
          <OAuthProviderButtons onSelect={onSelect} />
        </div>
      </VariantBlock>

      <VariantBlock
        label="Subset, three columns"
        caption="Google / Microsoft / GitHub — how unified's AuthScreen consumes it"
      >
        <div className="w-[360px]">
          <OAuthProviderButtons providers={THREE} columns={3} onSelect={onSelect} />
        </div>
      </VariantBlock>

      <VariantBlock
        label="Labeled row"
        caption='appearance="labeled" + signup verb (fe-react full-width shape)'
      >
        <div className="w-[360px]">
          <OAuthProviderButtons
            appearance="labeled"
            layout="row"
            mode="signup"
            providers={THREE}
            onSelect={onSelect}
          />
        </div>
      </VariantBlock>

      <VariantBlock
        label="Per-tile loading"
        caption="click any tile — its icon morphs to a Spinner, no relayout"
      >
        <div className="w-[360px]">
          <OAuthProviderButtons
            providers={THREE}
            columns={3}
            loadingProviderId={loadingId}
            onSelect={onSelect}
          />
        </div>
      </VariantBlock>
    </Section>
  );
}
